import { type ComponentType, type SVGProps } from 'react';
import MarkdownParser from 'components/rich-text/markdown-parser';
import styles from './index.module.scss';

export function IconBlock({
	IconComponent,
	title,
	body,
}: {
	IconComponent: ComponentType<SVGProps<SVGSVGElement>>;
	title: string;
	body: string;
}) {
	return (
		<div className={styles.iconBlock}>
			<div className={styles.iconWrapper}>
				<IconComponent className={styles.icon} />
			</div>
			<div className={styles.textWrapper}>
				<h5 className={styles.title} data-testid="icon-block-title">
					<MarkdownParser>{title}</MarkdownParser>
				</h5>
				<p className={styles.body} data-testid="icon-block-body">
					<MarkdownParser>{body}</MarkdownParser>
				</p>
			</div>
		</div>
	);
}

export type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;
